<template>
    <div>
        <div class="column">
            <div ref="dropZoneRef" class="dropzone"></div>
            <label class="checkbox is-pulled-right">
                <input type="checkbox" v-model="checked"> Descarga automatica
            </label>
        </div>
        <div class="column">
            <ExploredFiles :files="data.files"></ExploredFiles>
        </div>
    </div>
</template>
<script>
import Dropzone from 'dropzone'
import ExploredFiles from './ExploredFiles.vue';

export default {
    name: 'DropZone',
    components:{
        ExploredFiles
    },
    data(){
        return{
            data:{
                files:[]
            },
            checked: false,
            url: process.env.VUE_APP_FLASK_API_URL
        }
    },
    mounted() {
        const files = this.data.files
        const $=this
        new Dropzone(this.$refs.dropZoneRef, {
            url: `${this.url}/api/clean`,
            dictDefaultMessage: "Agrega los archivos a tratar aquí",
            init: function(){
                this.on("success", function(file, response) {
                    if(response.bad_lines.error_bad_lines && response.empty_columns.error_empty_columns){
                        $.$toast.error(`Ocurrio un error al tratar de corregir el archivo`, { 
                            position: "top-right",
                            duration: 5000
                        });
                    }else{
                        if(response.dup_lines.count > 0){
                            $.$toast.info(`Se eliminaron ${response.dup_lines.count} lineas duplicadas`,{ 
                                position: "top-right",
                                duration: 10000
                            });
                            $.$toast.success(`Archivo corregido exitosamente`,{ 
                                position: "top-right",
                                duration: 10000
                            });
                        }else{
                            $.$toast.success(`Archivo corregido exitosamente`,{ 
                                position: "top-right",
                                duration: 5000
                            });
                        }   
                    }
                    const url = window.URL.createObjectURL(new Blob([response.csv]))
                    if($.checked){
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', `fixed_${file.name}`) //or any other extension
                        document.body.appendChild(link)
                        link.click()
                    }
                    files.push({
                        "filename":file.name,
                        "csv": response.csv,
                        "delimiter":response.delimiter,
                        "bad_lines": response.bad_lines,
                        "dup_lines": response.dup_lines,
                        "empty_columns": response.empty_columns,
                        "url": url,
                        "auto_download": $.checked
                    });
                });
                this.on('error', function(file, errorMessage) {
                    console.log(errorMessage)
                })
            }
        });
    },
    watch:{
        data:{
            handler(newValue) {
                newValue
            },
            deep: true,
        }
    },
}
</script>
